// Renders a price + currency for display. Fallback to USD when the post
// was created without a currency (e.g. legacy rows or a buggy submission).
// The currency conversion question came up — answer: no conversion, just
// show the seller's listed currency. Cleaner intent, no exchange-rate API.

const PLACEHOLDER_CURRENCY = 'USD';

export function formatPrice(price, currencyCode) {
  if (price == null || price === '') return '';
  // Intl.NumberFormat.format(NaN) renders the literal string "NaN" — guard
  // here so a corrupted post (price='abc', or price=undefined coerced into
  // Number()) doesn't surface as garbage in the UI. Empty string = render
  // nothing (caller decides whether to show a fallback).
  const num = typeof price === 'number' ? price : Number(price);
  if (!Number.isFinite(num)) return '';
  const code = (currencyCode || PLACEHOLDER_CURRENCY).toUpperCase();
  // Intl.NumberFormat handles thousands separators + currency symbols
  // consistently across browsers. Fallback to a plain join if the runtime
  // doesn't recognize the currency (e.g. older mobile WebView with a
  // partial ICU). Both branches yield e.g. "USD 1,200".
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: code,
      currencyDisplay: 'code',
      maximumFractionDigits: 0,
    }).format(num);
  } catch {
    return `${code} ${num.toLocaleString()}`;
  }
}
